import { render, staticRenderFns } from "./ProcedureDomainUnsubscribeConfirm.vue?vue&type=template&id=51c08008&"
import script from "./ProcedureDomainUnsubscribeConfirm.vue?vue&type=script&lang=ts&"
export * from "./ProcedureDomainUnsubscribeConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports